import { JSX, SVGProps } from 'react';

export const QuoteIcon = (props: JSX.IntrinsicAttributes & SVGProps<SVGSVGElement>) => (
  <svg
    width={28}
    height={23}
    viewBox="0 0 28 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M21.704 22.624C19.688 22.624 18.08 21.928 16.88 20.536C15.68 19.096 15.08 17.152 15.08 14.704C15.08 11.632 16.064 8.824 18.032 6.28C20 3.736 23.312 1.84 27.968 0.591997V4.336C26.576 4.816 25.4 5.32 24.44 5.848C23.528 6.328 22.832 6.904 22.352 7.576C21.872 8.2 21.632 8.992 21.632 9.952C21.632 10.48 21.8 10.912 22.136 11.248C22.52 11.584 22.976 11.896 23.504 12.184C24.032 12.472 24.536 12.832 25.016 13.264C25.544 13.648 25.976 14.2 26.312 14.92C26.696 15.592 26.888 16.504 26.888 17.656C26.888 19.288 26.384 20.536 25.376 21.4C24.416 22.216 23.192 22.624 21.704 22.624ZM6.656 22.624C4.64 22.624 3.032 21.928 1.832 20.536C0.632 19.096 0.0320001 17.152 0.0320001 14.704C0.0320001 11.632 1.016 8.824 2.984 6.28C4.952 3.736 8.264 1.84 12.92 0.591997V4.336C11.528 4.816 10.352 5.32 9.392 5.848C8.48 6.328 7.784 6.904 7.304 7.576C6.824 8.2 6.584 8.992 6.584 9.952C6.584 10.48 6.752 10.912 7.088 11.248C7.472 11.584 7.904 11.896 8.384 12.184C8.912 12.472 9.44 12.832 9.968 13.264C10.496 13.648 10.928 14.2 11.264 14.92C11.648 15.592 11.84 16.504 11.84 17.656C11.84 19.288 11.336 20.536 10.328 21.4C9.368 22.216 8.144 22.624 6.656 22.624Z"
      fill="currentColor"
    />
  </svg>
);
